import logger from '@/modules/Logger';

export default {
  // disconnect the current connect and leave room
  async disconnect() {
    // release the hidden video track under screen share
    if (this.constraints.screen && this.localVideoTrack) {
      this.localVideoTrack.close();
    }
    
    // release video and audio resources
    this.localVideoTrack?.close();
    this.localAudioTrack?.close();

    // release device
    this.rtc.localTracks.map(track => { track.close() });

    // diconnect agora client
    await this.rtc.leave();
    logger.info('[Agora] Rtc leave', { operation: 'webrtc:disconnect' })
  }
}

